'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = urlJoin;

var _urlParse = require('url-parse');

var _urlParse2 = _interopRequireDefault(_urlParse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function removeHeadSlash(value) {
  if (/^\//.test(value)) {
    return value.slice(1);
  }
  return value;
}

function removeTrailingSlash(value) {
  if (/\/$/.test(value)) {
    return value.substr(value, value.length - 1);
  }
  return value;
}

function appendQuery(baseUrl, query) {
  var url = (0, _urlParse2.default)(baseUrl, true);
  url.set('query', Object.assign({}, url.query, query));
  return url.toString();
}

/**
 * A URL join implementation that handles segments that happen to be full URLs.
 */
function urlJoin(baseUrl) {
  var query = void 0;

  for (var _len = arguments.length, segments = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    segments[_key - 1] = arguments[_key];
  }

  var url = segments.reduce(function (memo, segment) {
    var parsedSegment = (0, _urlParse2.default)(segment, true);
    query = Object.assign({}, query, parsedSegment.query);
    return removeTrailingSlash(memo) + '/' + removeHeadSlash(parsedSegment.pathname);
  }, baseUrl);
  return appendQuery(url, query);
}